/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
export class GetProductBenefitsData extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    private productBenefitsDataUrl: string = '';
    constructor(productBenefitsDataUrl: string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'productBenefitsDataCache', cacheKey: 'productBenefitsDataCache' });
        this.productBenefitsDataUrl = productBenefitsDataUrl;
    }
    public getProductBenefitsDataUrl = () => this.productBenefitsDataUrl;
    public getCacheKey = () => `productBenefitsDataCache`;
    public getCacheObjectType = () => 'productBenefitsDataCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}
const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.productBenefitsDataUrl) {
        return new GetProductBenefitsData(inputData.config.productBenefitsDataUrl);
    }
    return new GetProductBenefitsData('');
};
async function action(input: GetProductBenefitsData, ctx: Msdyn365.IActionContext): Promise<any> {
    const productBenefitsDataJsonUrl = ctx.requestContext.app.config.productBenefitsDataUrl;
    const jsonUrl = productBenefitsDataJsonUrl || '';
    const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
    const productBenefitsData = res.data && res.data;
    return productBenefitsData;
}
export default Msdyn365.createObservableDataAction({
    id: 'productBenefitsData',
    action: <Msdyn365.IAction<any>>action,
    input: createInput
});